import { seatFacts, seatLayoutFor, type SeatCandidate } from "@anjabom/core";
export async function seatCardImage(
	candidate: SeatCandidate,
	note = "",
	toss = false,
): Promise<Blob> {
	const canvas = document.createElement("canvas");
	canvas.width = 1080;
	canvas.height = 1350;
	const ctx = canvas.getContext("2d");
	if (!ctx) throw new Error("이미지를 만들지 못했어요.");
	ctx.fillStyle = "#fff";
	ctx.fillRect(0, 0, 1080, 1350);
	ctx.fillStyle = "#17324d";
	ctx.font = "700 44px system-ui";
	ctx.fillText("앉아봄", 72, 92);
	const lines = (text: string, y: number, font: string, max = 936) => {
		ctx.font = font;
		let line = "",
			nextY = y;
		for (const char of text) {
			if (ctx.measureText(line + char).width > max) {
				ctx.fillText(line, 72, nextY);
				nextY += 58;
				line = "";
			}
			line += char;
		}
		if (line) ctx.fillText(line, 72, nextY);
		return nextY + 64;
	};
	let y = lines(
		`${candidate.venueName} · ${candidate.spaceName}`,
		172,
		"500 38px system-ui",
	);
	ctx.fillStyle = "#17324d";
	ctx.fillRect(56, y, 968, 130);
	ctx.fillStyle = "#fff";
	ctx.font = "700 52px system-ui";
	ctx.fillText(
		`${candidate.sectionCode} ${candidate.rowLabel}열 ${candidate.seatNumber}번`,
		80,
		y + 84,
		920,
	);
	y += 190;
	const layout = seatLayoutFor(candidate.venueId, candidate.spaceId);
	const facts = layout
		? seatFacts(
				layout,
				candidate.sectionCode,
				candidate.rowLabel,
				candidate.seatNumber,
			)
		: null;
	const section = layout?.floors
		.flatMap((f) => f.sections)
		.find(
			(s) =>
				s.label === candidate.sectionCode || s.id === candidate.sectionCode,
		);
	const row = section?.rows?.find((r) => r.label === candidate.rowLabel);
	const rowIndex = section?.rows?.indexOf(row!) ?? -1,
		seatIndex = row?.seats.indexOf(candidate.seatNumber) ?? -1;
	const pointX =
			row && seatIndex >= 0
				? Math.round((seatIndex / Math.max(1, row.seats.length - 1)) * 10)
				: null,
		pointY =
			section?.rows && rowIndex >= 0
				? Math.round((rowIndex / Math.max(1, section.rows.length - 1)) * 4)
				: null;
	for (let r = 0; r < 5; r++)
		for (let c = 0; c < 11; c++) {
			ctx.beginPath();
			ctx.arc(110 + c * 84, y + r * 44, 12, 0, Math.PI * 2);
			ctx.fillStyle = pointX === c && pointY === r ? "#b86b0b" : "#dfe2e7";
			ctx.fill();
		}
	y += 240;
	ctx.fillStyle = "#525760";
	ctx.font = "400 25px system-ui";
	ctx.fillText(
		pointX === null
			? "구역의 상대 위치는 확인하지 못했어요."
			: "자체 점 지도 · 구역 안 상대 위치예요. 실제 시야가 아니에요.",
		72,
		y,
	);
	y += 68;
	ctx.fillStyle = "#17324d";
	for (const line of facts?.lines.slice(1, 3) ?? [])
		y = lines(line, y, "500 34px system-ui");
	if (note.trim())
		y = lines(
			`앉아본 사람: ${note.replace(/[\d,]+\s*(?:만원|천원|원)|[₩$€£]\s*[\d,.]+/g, '[금액 제외]').slice(0, 90)}`,
			y + 20,
			"400 32px system-ui",
		);
	ctx.fillStyle = "#17324d";
	ctx.font = "500 30px system-ui";
	ctx.fillText(toss ? "토스에서 앉아봄 검색" : "anjabom.com", 72, 1280);
	const blob = await new Promise<Blob | null>((resolve) =>
		canvas.toBlob(resolve, "image/png"),
	);
	if (!blob) throw new Error("이미지를 저장하지 못했어요.");
	return blob;
}
